export const EligibilityTypes = {
  NONE: "NONE",
  ELIGIBLE: "ELIGIBLE",
  NOT_ELIGIBLE: "NOT_ELIGIBLE",
};
